// skipcq: JS-W1028
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';

const CHIP_COLOR = '#c8e650';
const CHIP_TEXT_COLOR = '#2a2319';

/**
 * @param {string} label
 * @param {number} count
 * @returns {string}
 */
function formatTagChipLabel(label, count) {
  return `${label} (${count})`;
}

/**
 * @param {object} props
 * @param {Array<{ label: string, count: number }>} props.tags
 * @param {boolean} [props.showCount]
 */
function BeerTagChips({ tags, showCount = true }) {
  if (!Array.isArray(tags) || tags.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75, pt: 0.5 }}>
      {tags.map((tagEntry) => (
        <Chip
          key={`${tagEntry.label}-${tagEntry.count}`}
          label={
            showCount
              ? formatTagChipLabel(tagEntry.label, tagEntry.count)
              : tagEntry.label
          }
          size="small"
          sx={{
            backgroundColor: CHIP_COLOR,
            color: CHIP_TEXT_COLOR,
            typography: 'caption',
            fontWeight: 600,
          }}
        />
      ))}
    </Box>
  );
}

BeerTagChips.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
    }),
  ),
  showCount: PropTypes.bool,
};

export default BeerTagChips;
